<template>
  <v-card color="white" class="pb-4 mb-2">
    <v-card-actions flat class="sblock-top-actions">
      <v-icon>mdi-drag</v-icon>
      <v-spacer></v-spacer>

      <v-btn icon @click="$emit('delete')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <s-block-type-info
      :s-block-type="SBlock.type">

    </s-block-type-info>
    <s-struct-list :s-block-type-id="SBlock.type.id" :s-struct-array="SBlock.struct">

    </s-struct-list>
  </v-card>
</template>

<script>
import SBlockTypeInfo from './SBlockTypeInfo'
import SStructList from './SStructsList'

/***
 * presentation and actions on the speech block
 * @description use with prop {Object} SBlock - speech block
 */

export default {
  name: 'SBlock',
  components: { SStructList, SBlockTypeInfo },
  props: {
    SBlock: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  .sblock-top-actions{
    background-color: whitesmoke!important;
  }
</style>
